import { createReducer } from '@reduxjs/toolkit';
import { clearUserDataAction, storeUserDataAction } from './UserActionCreators';
import { UserModel } from './UserModel';

export interface OfferDetailsReducerState {
  user: UserModel;
}

export const initialUserState: OfferDetailsReducerState = {
  user: {
    id: -1,
    firstName: '',
    lastName: '',
    email: '',
    owner: false,
    admin: false,
  },
};

export const userReducer = createReducer(initialUserState, (builder) => {
  builder.addCase(storeUserDataAction, (state, action) => {
    state.user = action.payload.user;
  });
  builder.addCase(clearUserDataAction, (state) => {
    state.user = initialUserState.user;
  });
});
